/**
 * LogbookQuickActions - Floating action button and quick actions drawer
 */

import React from 'react';
import { Plus, MapPin, Cloud, Navigation, FileText } from 'lucide-react';

const LogbookQuickActions = ({ showQuickActions, setShowQuickActions }) => {
  return (
    <>
      {/* Floating Action Button for Quick Actions */}
      <button
        onClick={() => setShowQuickActions(!showQuickActions)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 flex items-center justify-center z-50"
      >
        <Plus className="h-6 w-6" />
      </button>

      {/* Quick Actions Drawer */}
      {showQuickActions && (
        <div className="fixed bottom-24 right-6 bg-white rounded-lg shadow-xl p-4 z-40 w-64">
          <h3 className="font-medium mb-3">Quick Log Entry</h3>
          <div className="space-y-2">
            <button className="w-full text-left px-3 py-2 hover:bg-gray-50 rounded">
              <MapPin className="h-4 w-4 inline mr-2" />
              Position Report
            </button>
            <button className="w-full text-left px-3 py-2 hover:bg-gray-50 rounded">
              <Cloud className="h-4 w-4 inline mr-2" />
              Weather Observation
            </button>
            <button className="w-full text-left px-3 py-2 hover:bg-gray-50 rounded">
              <Navigation className="h-4 w-4 inline mr-2" />
              Course Change
            </button>
            <button className="w-full text-left px-3 py-2 hover:bg-gray-50 rounded">
              <FileText className="h-4 w-4 inline mr-2" />
              Custom Entry
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LogbookQuickActions;